import { Flex } from 'antd'
import { useNavigate } from 'react-router-dom'
import { MinimizeIconSVG } from 'src/assets/icons'
import { defaultHomePage } from 'src/app/shared/constants/app.constants'
import { getCriticalConfig } from 'src/app/store/masterSetup'
import { useSelector } from 'react-redux'
import './index.scss'

interface Props {
  isMenuMinimized: boolean
  handleMinimizeMenu: () => void
}

const PanelHeader = (props: Props) => {
  const { isMenuMinimized, handleMinimizeMenu } = props
  const navigate = useNavigate()
  const criticalConfig = useSelector(getCriticalConfig)

  const { swbLogo } = criticalConfig?.brandingImage || {}
  return (
    <Flex
      align='center'
      justify='center'
      className='panel-top'
      // style={{
      //   backgroundImage: `linear-gradient(180deg, ${backgroundColorGradients?.[0]} 50%, ${backgroundColorGradients?.[1]} 50%)`,
      //   backgroundSize: '100% 1px',
      //   backgroundPosition: 'bottom',
      //   backgroundRepeat: 'no-repeat',
      // }}
    >
      {isMenuMinimized ? (
        <MinimizeIconSVG className='minimize-icon' onClick={handleMinimizeMenu} />
      ) : (
        <Flex
          align='center'
          justify='space-between'
          gap={24}
          style={{ cursor: 'pointer', width: '100%', padding: '0 16px 0 24px' }}
        >
          <Flex
            onClick={() => {
              navigate(defaultHomePage)
            }}
          >
            <img src={swbLogo} alt='sunwest logo' className='swbLogo' />
          </Flex>
          <MinimizeIconSVG className='minimize-icon' onClick={handleMinimizeMenu} />
        </Flex>
      )}
    </Flex>
  )
}

export default PanelHeader
